var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _path3, _path4, _line25, _path5, _line26, _path6, _line27, _line28, _line29, _line30, _circle, _path7, _line31, _line32, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeLongFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 197 100 C 197 125, 125 150, 0 160 L 0 40 C 125 50, 197 75, 197 100 Z",
    strokeWidth: 3,
    fill: "#aaa",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 155 C 120 140, 90 140, 100 140 L 100 60 C 90 60, 120 60, 0 45 Z",
    fill: "#955726"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 35,
    y2: 150,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 145,
    x2: 70,
    y2: 145,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 140,
    x2: 97,
    y2: 140,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 135,
    x2: 100,
    y2: 135,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 130,
    x2: 100,
    y2: 130,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 125,
    x2: 100,
    y2: 125,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 120,
    x2: 100,
    y2: 120,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 115,
    x2: 100,
    y2: 115,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 110,
    x2: 100,
    y2: 110,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 105,
    x2: 100,
    y2: 105,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 100,
    y2: 100,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 95,
    x2: 100,
    y2: 95,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 90,
    x2: 100,
    y2: 90,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 85,
    x2: 100,
    y2: 85,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 100,
    y2: 80,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 75,
    x2: 100,
    y2: 75,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70,
    x2: 100,
    y2: 70,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 65,
    x2: 100,
    y2: 65,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 97,
    y2: 60,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 55,
    x2: 70,
    y2: 55,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 35,
    y2: 50,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 47,
    x2: 10,
    y2: 153,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 51,
    x2: 40,
    y2: 149,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 55,
    x2: 70,
    y2: 145,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 10 70 L 45 72 L 45 128 L 10 130 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 80 L 35 80 L 35 90 L 45 90",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 85,
    x2: 80,
    y2: 85,
    stroke: "black",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 95 L 35 95 L 35 105 L 45 105",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 100,
    x2: 80,
    y2: 100,
    stroke: "black",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 110 L 35 110 L 35 120 L 45 120",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 115,
    x2: 80,
    y2: 115,
    stroke: "black",
    strokeWidth: 4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 85,
    x2: 30,
    y2: 85,
    stroke: "black",
    strokeWidth: 4
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 30,
    y2: 100,
    stroke: "black",
    strokeWidth: 4
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 115,
    x2: 30,
    y2: 115,
    stroke: "black",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 100,
    r: 20,
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 88 L 120 90 L 120 110 L 100 112 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 98,
    x2: 127,
    y2: 98,
    stroke: "black",
    strokeWidth: 2.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 102,
    x2: 127,
    y2: 102,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 140,
    cy: 75,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 160,
    cy: 80,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 180,
    cy: 90,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 180,
    cy: 110,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 160,
    cy: 120,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 140,
    cy: 125,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLongFront);
export default __webpack_public_path__ + "static/media/ThreeLongFront.13fb291212fff47fe4625603bbc2221c.svg";
export { ForwardRef as ReactComponent };